(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["bc-cart-controller"] && !Shopify.designMode) return;
  try {
    (() => {
  const messages = () => document.getElementById('bc-cart-messages')?.dataset || {};
  let busy = false;
  const root = () => window.Shopify?.routes?.root || '/';
  const pendingControls = new Map();
  function lock() {
    busy = true;
    document.querySelectorAll('product-form-component button[type="submit"], .bc-cart-quick-add button, .cart__checkout-button').forEach(button => {
      pendingControls.set(button, button.disabled);
      button.disabled = true;
    });
    document.querySelectorAll('.bc-bundle-action').forEach(link => link.setAttribute('aria-disabled', 'true'));
  }
  function unlock() {
    busy = false;
    pendingControls.forEach((disabled, button) => { if (button.isConnected) button.disabled = disabled; });
    pendingControls.clear();
    document.querySelectorAll('.bc-bundle-action').forEach(link => link.removeAttribute('aria-disabled'));
  }
  function notifyCart(data, productId) {
    document.dispatchEvent(new CustomEvent('cart:update', {
      bubbles: true,
      detail: { resource: {}, sourceId: 'bc-cart', data: { source: 'bc-cart', productId, itemCount: 1, sections: data.sections } }
    }));
  }
  async function add(formData) {
    const sections = [...new Set([...document.querySelectorAll('cart-items-component[data-section-id]')].map(node => node.dataset.sectionId))].slice(0, 5);
    formData.set('sections', sections.join(','));
    formData.set('sections_url', window.location.pathname);
    const response = await fetch(root() + 'cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: formData });
    const result = await response.json();
    if (!response.ok || result.status) throw new Error(result.description || result.message || messages().error);
    return result;
  }
  function errorAt(element, message) {
    const error = element.querySelector('[role="alert"]');
    if (error) { error.textContent = message; error.hidden = false; }
  }
  document.addEventListener('click', async event => {
    const link = event.target.closest?.('.bc-bundle-action');
    if (!link || event.button > 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    event.preventDefault();
    if (busy) return;
    const bundle = link.closest('#bc-bundle-save');
    if (!bundle) return;
    const scope = bundle.closest('.shopify-section') || document;
    const component = [...scope.querySelectorAll('product-form-component')].find(node => node.dataset.productId === bundle.dataset.productId)
      || [...document.querySelectorAll('product-form-component')].find(node => node.dataset.productId === bundle.dataset.productId);
    const form = component?.querySelector('form');
    const submit = form?.querySelector('button[type="submit"]');
    if (!form) { errorAt(bundle, messages().error); return; }
    const sizeGroup = scope.querySelector('[data-is-size-option="true"]');
    if ((sizeGroup && !sizeGroup.querySelector('input:checked, select option:checked:not([value=""])')) || submit?.disabled) {
      errorAt(bundle, messages().size);
      sizeGroup?.scrollIntoView({ block: 'center', behavior: 'smooth' });
      return;
    }
    if (!form.reportValidity()) return;
    const data = new FormData(form);
    const picker = scope.querySelector('variant-picker');
    if (picker?.isSizeSelectionReady && !picker.isSizeSelectionReady(data.get('id'))) { errorAt(bundle, messages().size); return; }
    if (!data.get('id')) { errorAt(bundle, messages().size); return; }
    data.set('quantity', '1');
    const bundleError = bundle.querySelector('[role="alert"]');
    if (bundleError) bundleError.hidden = true;
    const originalText = link.textContent;
    link.textContent = messages().adding;
    lock();
    try {
      await add(data);
      const destination = new URL(link.href, location.origin);
      const preview = new URL(location.href).searchParams.get('preview_theme_id');
      if (preview) destination.searchParams.set('preview_theme_id', preview);
      location.assign(destination.href);
    } catch (error) {
      errorAt(bundle, error.message || messages().error);
      link.textContent = originalText;
      unlock();
    }
  });
  document.addEventListener('toggle', event => {
    const card = event.target;
    if (!card.matches?.('.bc-cart-recommendation') || !card.open) return;
    card.parentElement.querySelectorAll('.bc-cart-recommendation[open]').forEach(other => { if (other !== card) other.open = false; });
  }, true);
  document.addEventListener('change', event => {
    const select = event.target.closest?.('[data-bc-option]');
    if (!select) return;
    const card = select.closest('.bc-cart-recommendation');
    const values = [...card.querySelectorAll('[data-bc-option]')].map(node => node.value);
    let variants;
    try { variants = JSON.parse(card.dataset.variants); } catch { return; }
    const variant = variants.find(item => item.options.every((value, i) => value === values[i]));
    const button = card.querySelector('button[type="submit"]');
    const complete = values.every(Boolean);
    card.querySelector('input[name="id"]').value = variant?.id || '';
    button.disabled = busy || !variant?.available;
    button.textContent = !complete ? messages().select : !variant?.available ? messages().unavailable : messages().add + ' · ' + new Intl.NumberFormat(document.documentElement.lang, { style: 'currency', currency: card.dataset.currency }).format(variant.price / 100);
    card.querySelector('[role="alert"]').hidden = true;
    if (variant?.featured_image?.src) card.querySelector('summary img').srcset = variant.featured_image.src + (variant.featured_image.src.includes('?') ? '&' : '?') + 'width=140 140w';
  });
  document.addEventListener('submit', async event => {
    const form = event.target.closest?.('.bc-cart-quick-add');
    if (!form) return;
    event.preventDefault();
    if (busy || !form.reportValidity() || !form.elements.id.value) return;
    const card = form.closest('.bc-cart-recommendation');
    const button = form.querySelector('button');
    const label = button.textContent;
    const data = new FormData(form);
    data.set('quantity', '1');
    lock();
    button.textContent = messages().adding;
    try {
      const result = await add(data);
      notifyCart(result, card.dataset.bcProductId);
    } catch (error) {
      errorAt(form, error.message || messages().error);
    } finally {
      button.textContent = label;
      unlock();
    }
  });
  window.addEventListener('pageshow', () => unlock());
})();

  document.addEventListener('click', event => {
    const button = event.target.closest?.('[data-bc-slide]');
    if (!button) return;
    const slider = button.closest('.bc-cart-recommendations').querySelector('.bc-cart-slider');
    const card = slider.querySelector('.bc-cart-recommendation');
    if (!card) return;
    slider.scrollBy({ left: Number(button.dataset.bcSlide) * (card.getBoundingClientRect().width + 12), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["bc-kiwi-position"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('bc-kiwi-position')){
customElements.define('bc-kiwi-position',class extends HTMLElement{
connectedCallback(){
this.root=this.closest('.shopify-section');
if(!this.root)return;
this.place=()=>{
const target=this.root.querySelector('[data-is-size-option] legend>div');
const found=this.root.querySelector('.ks-container-app-block');
if(found?.querySelector('.ks-calculator-modal-button'))this.widget=found.closest('.shopify-app-block') || found;
if(!target||!this.widget||target.contains(this.widget))return;
this.observer.disconnect();
const wrapper=this.widget.parentElement;
target.append(this.widget);
const text=this.widget.querySelector('._ks_text');
if(text)text.textContent=this.dataset.label;
if(wrapper?.classList.contains('shopify-app-block')&&!wrapper.children.length)wrapper.hidden=true;
this.observer.observe(this.root,{childList:true,subtree:true});
};
this.observer=new MutationObserver(this.place);
this.observer.observe(this.root,{childList:true,subtree:true});
this.place();
}
disconnectedCallback(){this.observer?.disconnect();}
});
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["bc-mobile-cart"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('bc-mobile-cart')) {
  customElements.define('bc-mobile-cart', class extends HTMLElement {
    connectedCallback() {
      this.root = document.getElementById('shopify-section-' + this.dataset.sectionId);
      this.details = this.root?.querySelector('.product-details');
      this.button = this.querySelector('[data-sticky-button]');
      this.price = this.querySelector('[data-sticky-price]');
      if (!this.details || !this.button) return;
      this.media = matchMedia('(max-width:749px)');
      this.schedule = () => {
        if (this.frame) return;
        this.frame = requestAnimationFrame(() => { this.frame = 0; this.sync(); });
      };
      this.activate = () => {
        const native = this.details.querySelector('[ref="addToCartButton"]');
        const picker = this.details.querySelector('variant-picker');
        if (picker?.sizeGroup && !picker.hasSizeIntent) {
          picker.sizeGroup.scrollIntoView({block:'center', behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});
          picker.sizeGroup.querySelector('input:not(:disabled), select')?.focus({preventScroll:true});
        } else if (native && !native.disabled) {
          native.click();
        }
      };
      this.button.addEventListener('click', this.activate);
      window.addEventListener('scroll', this.schedule, {passive:true});
      window.addEventListener('load', this.schedule, {once:true});
      window.addEventListener('resize', this.schedule);
      this.observer = new MutationObserver(this.schedule);
      this.observer.observe(this.details, {subtree:true, childList:true, characterData:true, attributes:true, attributeFilter:['disabled','class','aria-busy']});
      this.resizeObserver = new ResizeObserver(this.schedule);
      this.resizeObserver.observe(this.details);
      this.sync();
    }
    sync() {
      const native = this.details.querySelector('[ref="addToCartButton"]');
      if (!native) { this.hidden = true; return; }
      const rect = native.getBoundingClientRect();
      const preview = document.getElementById('PBarNextFrame');
      const previewRect = preview?.getBoundingClientRect();
      const offset = previewRect && previewRect.height > 0 && previewRect.bottom >= window.innerHeight - 2 ? Math.min(80, Math.max(0, window.innerHeight - previewRect.top)) : 0;
      this.style.setProperty('--bc-preview-offset', offset + 'px');
      // Keep the floating card until the entire native button is visible.
      // Re-evaluate on every scroll so it returns when scrolling back above it.
      const pickerRect = this.details.querySelector('variant-picker')?.getBoundingClientRect();
      const choosing = pickerRect && pickerRect.bottom > 0 && pickerRect.top < window.innerHeight - offset;
      this.hidden = !this.media.matches || rect.height <= 0 || rect.bottom > 0 || choosing;
      const picker = this.details.querySelector('variant-picker');
      const needsSize = !!picker?.sizeGroup && !picker.hasSizeIntent;
      this.button.textContent = native.querySelector('.add-to-cart-text__content')?.textContent?.trim() || native.textContent.trim();
      this.button.disabled = native.disabled && !needsSize;
      const price = this.details.querySelector('product-price .price');
      if (price) this.price.textContent = price.textContent.trim();
    }
    disconnectedCallback() {
      cancelAnimationFrame(this.frame);
      window.removeEventListener('scroll',this.schedule);
      window.removeEventListener('load',this.schedule);
      window.removeEventListener('resize',this.schedule);
      this.button?.removeEventListener('click',this.activate);
      this.observer?.disconnect();
      this.resizeObserver?.disconnect();
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
